<template>
  <div class='privacy_wrap'>
    <h2 @click='fold'>{{title}}
      <span :class='{down:!onOff}'></span>
    </h2>
    <div v-show='onOff'>
      <p v-if=''>{{partOne}}</p>
      <p v-if=''>{{partTwo}}</p>
      <p v-if=''>{{partTh}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    partOne: String,
    partTwo: String,
    partTh: String
  },
  data() {
    return {
      onOff: false
    }
  },
  components: {},
  methods: {
    fold() {
      this.onOff = !this.onOff
    }
  }
}
</script>

<style lang='less' scoped>
.privacy_wrap {
  border-top: 1px solid #f2f2f2;
  h2 {
    position: relative;
    margin: 20px 0;
    font-size: 20px;
    color: #1e1e1e;
    height: 36px;
    line-height: 36px;
    padding-right: 11px;
    cursor: pointer;
    span {
      position: absolute;
      right: 0;
      top: 13.5px;
      width: 11px;
      height: 9px;
      background: url('~@img/icons.png') no-repeat right
        center;
    }
    span.down {
      background-position: left center;
    }
    &:hover {
      padding-left: 18px;
      border-left: 3px solid #ffb400;
      color: #ffb400;
    }
  }
  & > div {
    margin-bottom: 25px;
  }
  p {
    font-size: 14px;
    color: #525252;
    line-height: 25px;
    text-indent: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// fold.vue?63924443